import { render, staticRenderFns } from "./BookingEdit.vue?vue&type=template&id=22441ae6&scoped=true&"
import script from "./BookingEdit.vue?vue&type=script&lang=js&"
export * from "./BookingEdit.vue?vue&type=script&lang=js&"
import style0 from "./BookingEdit.vue?vue&type=style&index=0&id=22441ae6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22441ae6",
  null
  
)

export default component.exports